// core Swiper
import Swiper from 'swiper';
import { Navigation, Thumbs, Autoplay, Zoom } from 'swiper/modules';

// Import all CSS
import 'swiper/css';
//import 'swiper/css/navigation'; //Used in theme
import 'swiper/css/thumbs';
import 'swiper/css/zoom';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.car-gallery').forEach((gallery) => {
        const mainSliderEl = gallery.querySelector('.main-slider');
        const thumbSliderEl = gallery.querySelector('.thumb-slider');
        if (!mainSliderEl || !thumbSliderEl) return;

        const rangeButtons = gallery.querySelectorAll('.scroll-to-exterior, .scroll-to-interior');
        // Thumbs Swiper
        const thumbSwiper = new Swiper(thumbSliderEl, {
            modules: [Thumbs],
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true
        });

        // Main Swiper
        const mainSwiper = new Swiper(mainSliderEl, {
            modules: [Navigation, Thumbs, Autoplay, Zoom],
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: gallery.querySelector('.swiper-button-next'),
                prevEl: gallery.querySelector('.swiper-button-prev'),
            },
            thumbs: {
                swiper: thumbSwiper
            },
            zoom: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            on: {
                slideChange() {
                    updateRangeButtons(this.activeIndex, rangeButtons);
                }
            }
        });

        // Section buttons
        rangeButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const slideIndex = parseInt(btn.dataset.slide, 10);
                mainSwiper.slideTo(slideIndex);
            });
        });

        // Ensure thumbs click updates main slider on mobile
        thumbSwiper.slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                mainSwiper.slideTo(index);
            });
        });

        function updateRangeButtons(currentSlide, rangeButtons) {
            rangeButtons.forEach(btn => {
                const start = parseInt(btn.dataset.slide, 10);
                const end = parseInt(btn.dataset.slideend, 10);
                if (currentSlide >= start && currentSlide <= end) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
        }
    });

});
